export default __webpack_public_path__ + "static/media/add_game.dcf50bf9.svg";